@use '../../scss/utility';
@use 'dropdown-vars';
@use '../grey-box/grey-box-vars';
@use '../list-group/list-group-vars';

:host {
  @include dropdown-vars.wb-dropdown-vars;

  display: block;
  position: relative;

  .caret-icon {
    position: absolute;
    z-index: 1;
    pointer-events: none;
  }
}

.button {
  display: flex;
  align-items: center;
  color: var(--grey-box-input-color);
  background-color: transparent;
  width: 100%;
  border: none;
  z-index: 1;
  cursor: pointer;
  @include utility.wb-text(
    'l',
    (
      responsive: false,
    )
  );
  padding: var(--grey-box-padding-block-start) var(--grey-box-padding-inline-end) var(--grey-box-padding-block-end) var(--grey-box-padding-inline-start);

  &:focus {
    outline: 0;
  }
}

.label {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: calc(100% - var(--grey-box-action-size));
  white-space: nowrap;
}

.wrapper {
  display: grid;
  position: relative;

  .overlay,
  ::slotted(.wb-control-hint),
  ::slotted(.wb-control-error) {
    grid-row: 1;
    grid-column: 1;
  }
}

.overlay {
  @include list-group-vars.wb-list-group-vars;
  position: absolute;
  inset-inline: 0;
  inset-block-start: var(--dropdown-overlay-inset-block-start);
  z-index: utility.$wb-z-index-popover;
  width: 100%;
  max-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  opacity: 0;
  transform: translate3d(0, utility.wb-pixel-to-rem(-4px), 0);
  transition:
    opacity var(--dropdown-overlay-transition-duration) var(--wb-fade),
    transform var(--dropdown-overlay-transition-duration) var(--wb-move),
    max-height 0s var(--dropdown-overlay-transition-duration);
  box-sizing: border-box;
  border: var(--list-group-border-weight) solid var(--list-group-border-color);

  @media (prefers-reduced-motion) {
    transition:
      transform 0s,
      max-height 0s;
  }
}

slot[name='message']::slotted(*) {
  margin-inline-start: var(--grey-box-hint-padding-inline-start);
}

:host([size='s']) {
  @include grey-box-vars.wb-grey-box-s-hint-vars;

  .button {
    @include utility.wb-text(
      'm',
      (
        responsive: false,
      )
    );
  }
}

:host([size='m']) {
  @include grey-box-vars.wb-grey-box-m-hint-vars;
}

:host([size='l']) {
  @include grey-box-vars.wb-grey-box-l-hint-vars;
}

:host(:not([open])) .overlay {
  pointer-events: none;
  visibility: hidden;
}

:host([open]) {
  .overlay {
    white-space: nowrap;
    height: auto;
    opacity: 1;
    transform: translate3d(0, 0, 0);
    max-height: utility.wb-pixel-to-rem(280px);
    transition:
      opacity var(--dropdown-overlay-transition-duration) var(--wb-fade),
      transform var(--dropdown-overlay-transition-duration) var(--wb-move),
      max-height 0s 0s;

    @media (prefers-reduced-motion) {
      transition:
        transform 0s,
        max-height 0s;
    }
  }
}

:host([disabled]) {
  pointer-events: none;
}

:host([open][list-behaviour='inline']) {
  @include dropdown-vars.wb-dropdown-inline-vars;

  .overlay {
    position: relative;
    margin-block-start: var(--dropdown-gap);
  }
}
